import React, { useState } from "react";
import { Play, Camera, ArrowUpRight } from "lucide-react";
import { MEDIA_WALL } from "../../mock";
import { Reveal, SectionHeading } from "../common";
import VideoModal from "../VideoModal";

export default function MediaWall() {
  const [active, setActive] = useState(null);

  return (
    <section className="relative bg-ivi-slate py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 font-heading text-[12px] font-bold uppercase tracking-[0.18em] text-ivi-lime ring-1 ring-white/15">
              <Camera className="h-3.5 w-3.5" /> From the field
            </span>
            <h2 className="mt-5 font-heading text-[34px] font-extrabold leading-[1.1] tracking-[-0.02em] text-white sm:text-[46px]">
              Moments that stay with you
            </h2>
            <p className="mt-4 text-[17px] leading-relaxed text-white/70">
              Turtles released at dawn, classrooms full of laughter, rice paddies at golden hour.
              Every photo and film below was captured by IVI volunteers and coordinators.
            </p>
          </div>
          <p className="text-[14px] font-semibold uppercase tracking-[0.18em] text-white/45">
            Tap a tile to play
          </p>
        </div>

        <div className="mt-12 grid auto-rows-[210px] grid-cols-1 gap-4 sm:grid-cols-2 lg:auto-rows-[240px] lg:grid-cols-4 lg:grid-flow-row-dense">
          {MEDIA_WALL.map((m, i) => (
            <Reveal key={m.id} delay={i * 70} className={m.span}>
              <button
                type="button"
                onClick={() => m.type === "video" && setActive(m)}
                className="group relative h-full w-full overflow-hidden rounded-3xl text-left ring-1 ring-white/10"
              >
                <img
                  src={m.type === "video" ? m.poster : m.src}
                  alt={m.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.08]"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-ivi-slate/85 via-ivi-slate/10 to-transparent" />

                {m.type === "video" && (
                  <span className="absolute inset-0 grid place-items-center">
                    <span className="grid h-20 w-20 place-items-center rounded-full bg-white/20 ring-1 ring-white/40 backdrop-blur-md transition-transform duration-300 group-hover:scale-110">
                      <span className="grid h-14 w-14 place-items-center rounded-full bg-ivi-green text-white">
                        <Play className="ml-0.5 h-6 w-6 fill-current" />
                      </span>
                    </span>
                  </span>
                )}

                <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 font-heading text-[11px] font-bold uppercase tracking-[0.14em] text-ivi-greenDark">
                  {m.tag}
                </span>

                <span className="absolute inset-x-4 bottom-4 flex items-end justify-between gap-3">
                  <span className="font-heading text-[16px] font-bold leading-snug text-white drop-shadow">
                    {m.title}
                  </span>
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/15 text-white opacity-0 ring-1 ring-white/30 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:-translate-y-1">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <VideoModal
        open={!!active}
        onOpenChange={(v) => !v && setActive(null)}
        videoId={active?.videoId}
        title={active?.title}
      />
    </section>
  );
}
